import * as React from 'react';
import * as styles from './styles.css';
import { LinkButton } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';

export interface IFileChooseProps {
  buttonText: string;
  multiple?: boolean;
  accept?: string;
  onFileSelect(files: FileList | null): void;
}

export const FileChoose: React.FC<IFileChooseProps> = props => {
  const isDesktop = useDeviceType() === 'desktop';

  const { onFileSelect, multiple, buttonText, accept } = props;
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFileSelect(e.target.files);
    },
    [onFileSelect],
  );

  return (
    <label className={styles['field']}>
      <input
        className={styles['input']}
        type="file"
        onChange={handleChange}
        multiple={multiple}
        data-testid="file-choose"
        accept={accept}
      />
      <div className={styles['upload-icon']}></div>
      <LinkButton theme={isDesktop ? 'stroke_primary' : 'fill_white_primary'} size="XS" fullWidth={!isDesktop}>
        {buttonText}
      </LinkButton>
    </label>
  );
};
